// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entities-list[data-v-50784cb4]{max-width:1280px;margin:0 auto}.entities-list__seo-text[data-v-50784cb4]{margin:30px 0}.entities-list__seo-text__title[data-v-50784cb4]{text-align:center;margin-bottom:10px}.entities-list__seo-text__description[data-v-50784cb4]{text-align:justify}", ""]);
// Exports
module.exports = exports;
